import { message } from "antd";
import API from "./API";

// user registrations api
export const userRegistration = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`register/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
export const userUpdate = async (id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`register/${id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
// all user list api
export const getUserList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`register/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
// user login api
export const userLogin = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`login/`, fromData, {
    headers: { "Content-Type": "application/json" },
    Authorization: `Bearer ${access}`,
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
// client create and get api
export const postClients = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/addnewclient/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
export const getclientslist = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/addnewclient/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
export const updateClients = async (client_id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/addnewclient/${client_id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};

// do create and get api ,update
export const postDo = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/addnewdo/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
export const getDoData = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/do-get-view/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
export const getDeliveryOrderDetailsById = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/order-details/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
export const orderUpdate = async (id, formdata) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/order-details/${id}`, formdata, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
export const deleteOrderbyAdmin = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/order-details/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};

// do assigne create api
export const postAssignDo = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/do-assign-list/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
export const updateAssignDo = async (id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/do-assign-list/${id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};

// dispatch  creation

export const postLifterDispatch = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/lifter-dispatch/`, fromData, {
    headers: { Authorization: `Bearer ${access}` },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
export const updateLifterDispatch = async (id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/dispatch-view/${id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
// dispatch get api view
export const getDispatch = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/dispatch-view/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
export const deleteOrder = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/lifter-dispatch/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
//freight paymet  creation  and get api

export const freightPaymetGet = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/freight-pay-get-view/`, formData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
export const freightPaymet = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/freight-pay-create-view/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
// get do by client list
export const getAllDoByClient = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/do-view-by-client/`, formData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
// lifter payment creation  and get api
export const getLifterPaymentByDoId = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/lifter-get-payment/`, formData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
export const postLifterPayment = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/lifter-payment/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
// client payment creation  and get api
export const getClientPaymentByDoId = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/client-get-payment/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
export const postClientPayment = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/client-payment/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};

// do bill create  and get api view
export const getDoBill = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/bill-get-view/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
export const postDoBill = async (data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/bill-view/`, data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};

export const reportsApi = async ({ limit, offset, ...data }) => {
  const access = JSON.parse(localStorage.getItem("access"));

  // query params me limit aur offset bhej rahe hain
  const query = new URLSearchParams({ limit, offset }).toString();

  const response = await API.post(
    `api/reports-view/?${query}`,
    data, // baki POST body
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    }
  ).catch((err) => message.error("Request failed."));

  return response ? response.data : {};
};

export const updateDo = async (id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/addnewdo/${id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};
export const updateDispatch = async (id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/lifter-dispatch/${id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};

export const dashboardApi = async (data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/dashboard/`, data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => message.error("regisration failed."));
  return response ? response.data : {};
};

export const fetchPermission = async (userId) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));
    const response = await API.get(`permissions/${userId}/`, {
      headers: { Authorization: `Bearer ${access}` },
    });
    return response.data || { user_id: userId, pages: [] };
  } catch (err) {
    console.error(err);
    message.error("Failed to fetch permissions.");
    return { user_id: userId, pages: [] };
  }
};

// ✅ Save / Update permissions for a user
export const savePermission = async (userId, pages) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));
    const response = await API.post(
      "permissions/",
      { user_id: userId, pages },
      { headers: { Authorization: `Bearer ${access}` } }
    );
    message.success("Permissions saved successfully!");
    return response.data;
  } catch (err) {
    console.error(err);
    message.error("Failed to save permissions.");
    return null;
  }
};

// NEW: Export Custom Report to Excel
export const exportCustomReportExcel = async (params) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));
    const response = await API.get(`/api/export-custom-report/`, {
      params: {
        com_name: params.com_name,
        party_id: params.party_id || "",
        from_date: params.from_date || "",
        to_date: params.to_date || "",
      },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });

    return {
      success: true,
      data: response.data,
      headers: response.headers,
    };
  } catch (error) {
    console.error("Export API Error:", error);
    return {
      success: false,
      error: error.response?.data || error.message,
    };
  }
};

export const exportDoStatusExcel = async (params) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));

    // Build query parameters
    const queryParams = {
      com_name: params.com_name || localStorage.getItem("com_name"),
      year: params.year || new Date().getFullYear(),
      party_name: params.party_name || "",
      do_no: params.do_no || "",
      lifting_status: params.lifting_status || "",
      user_type: params.user_type || localStorage.getItem("user_type"),
    };

    // Add lifter_id if user is a Lifter
    if (queryParams.user_type === "Lifter") {
      queryParams.lifter_id =
        params.lifter_id || localStorage.getItem("user_id");
    }

    const response = await API.get(`/api/export-do-status/`, {
      params: queryParams,
      responseType: "blob", // Important for file download
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });

    return {
      success: true,
      data: response.data,
      headers: response.headers,
    };
  } catch (error) {
    console.error("Export DO Status API Error:", error);
    return {
      success: false,
      error: error.response?.data || error.message,
    };
  }
};

export const exportDoPendingForBillExcel = async (params) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));

    // Build query parameters
    const queryParams = {
      com_name: params.com_name || localStorage.getItem("com_name"),
      year: params.year || new Date().getFullYear(),
      client_name: params.client_name || "",
      do_no: params.do_no || "",
      lifting_status: params.lifting_status || "",
      user_type: params.user_type || localStorage.getItem("user_type"),
    };

    // Add lifter_id if user is a Lifter
    if (queryParams.user_type === "Lifter") {
      queryParams.lifter_id =
        params.lifter_id || localStorage.getItem("user_id");
    }

    const response = await API.get(`/api/export-do-pending-bill/`, {
      params: queryParams,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });

    return {
      success: true,
      data: response.data,
      headers: response.headers,
    };
  } catch (error) {
    console.error("Export DO Pending for Bill API Error:", error);
    return {
      success: false,
      error: error.response?.data || error.message,
    };
  }
};

export const exportDispatchStatusExcel = async (params) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));

    const queryParams = {
      com_name: params.com_name || localStorage.getItem("com_name"),
      year: params.year || new Date().getFullYear(),
      client_id: params.client_id || "",
      do_id: params.do_id || "",
      vehicle_no: params.vehicle_no || "",
      user_type: params.user_type || localStorage.getItem("user_type"),
    };

    // Add lifter_id if user is a Lifter
    if (queryParams.user_type === "Lifter") {
      queryParams.lifter_id =
        params.lifter_id || localStorage.getItem("user_id");
    }

    const response = await API.get(`/api/export-dispatch-status/`, {
      params: queryParams,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });

    return {
      success: true,
      data: response.data,
      headers: response.headers,
    };
  } catch (error) {
    console.error("Export Dispatch Status API Error:", error);
    return {
      success: false,
      error: "Failed to export report",
    };
  }
};

export const exportMonthlyReportExcel = async (params) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));
    
    // Build query parameters
    const queryParams = {
      com_name: params.com_name || localStorage.getItem("com_name"),
      month: params.month,
      year: params.year || new Date().getFullYear(),
      truck_owner_name: params.truck_owner_name || "",
      check_no: params.check_no || "",
      check_date: params.check_date || "",
      do_no: params.do_no || "",
      user_type: params.user_type || localStorage.getItem("user_type"),
    };
    
    // Add lifter_id if user is a Lifter
    // if (queryParams.user_type === "Lifter") {
    //   queryParams.lifter_id = params.lifter_id || localStorage.getItem("user_id");
    // }
    
    const response = await API.get(`/api/export-monthly-report/`, {
      params: queryParams,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });

    return {
      success: true,
      data: response.data,
      headers: response.headers,
    };
  } catch (error) {
    console.error("Export Monthly Report API Error:", error);
    
    // Handle blob error response
    if (error.response?.data instanceof Blob) {
      try {
        const errorText = await error.response.data.text();
        return {
          success: false,
          error: errorText || "Failed to export report",
        };
      } catch {
        return {
          success: false,
          error: "Failed to export report",
        };
      }
    }
    
    return {
      success: false,
      error: error.response?.data || error.message,
    };
  }
};



export const exportYearlyReportExcel = async (params) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));
    
    // Build query parameters
    const queryParams = {
      com_name: params.com_name || localStorage.getItem("com_name"),
      year: params.year || new Date().getFullYear(),
      truck_owner_name: params.truck_owner_name || "",
      check_no: params.check_no || "",
      check_date: params.check_date || "",
      do_no: params.do_no || "",
      user_type: params.user_type || localStorage.getItem("user_type"),
    };
    
    // if (queryParams.user_type === "Lifter") {
    //   queryParams.lifter_id = params.lifter_id || localStorage.getItem("user_id");
    // }
    
    const response = await API.get(`/api/export-yearly-report/`, {
      params: queryParams,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });

    return {
      success: true,
      data: response.data,
      headers: response.headers,
    };
  } catch (error) {
    console.error("Export Yearly Report API Error:", error);
    
    // Handle blob error response
    if (error.response?.data instanceof Blob) {
      try {
        const errorText = await error.response.data.text();
        return {
          success: false,
          error: errorText || "Failed to export report",
        };
      } catch {
        return {
          success: false,
          error: "Failed to export report",
        };
      }
    }
    
    return {
      success: false,
      error: error.response?.data || error.message,
    };
  }
};

export const exportFreightPaymentRegisterExcel = async (params) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));
    const queryParams = {
      com_name: params.com_name || localStorage.getItem("com_name"),
      year: params.year || "",
      do_no: params.do_no || "",
      vehicle_no: params.vehicle_no || "",
      check_no: params.check_no || "",
      check_date: params.check_date || "",
    };
    const response = await API.get(`/api/export-freight-payment-register/`, {
      params: queryParams,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });

    return {
      success: true,
      data: response.data,
      headers: response.headers,
    };
  } catch (error) {
    if (error.response && error.response.data instanceof Blob) {
      try {
        const errorText = await error.response.data.text();
        console.error("Error message from server:", errorText);
        return {
          success: false,
          error: errorText,
        };
      } catch (e) {
      }
    }
    return {
      success: false,
      error: error.response?.data?.message || error.message || "Failed to export report",
    };
  }
};

export const exportPendingFreightPaymentExcel = async (params) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));
    
    const queryParams = {
      com_name: params.com_name || localStorage.getItem("com_name"),
      year: params.year || new Date().getFullYear(),
      do_no: params.do_no || "",
      client_name: params.client_name || "",
      vehicle_no: params.vehicle_no || "",
    };

    const response = await API.get(`/api/export-pending-freight-payment/`, {
      params: queryParams,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });

    return {
      success: true,
      data: response.data,
      headers: response.headers,
    };
  } catch (error) {
    // Handle blob error responses
    if (error.response && error.response.data instanceof Blob) {
      try {
        const errorText = await error.response.data.text();
        console.error("Error message from server:", errorText);
        return {
          success: false,
          error: errorText,
        };
      } catch (e) {
        console.error("Failed to parse error blob:", e);
      }
    }
    
    return {
      success: false,
      error: error.response?.data?.message || error.message || "Failed to export pending freight payment report",
    };
  }
};

export const exportTdsFreightListExcel = async (params) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));

    const queryParams = {
      com_name: params.com_name || localStorage.getItem("com_name"),
      year: params.year || new Date().getFullYear(),
      month: params.month || new Date().getMonth() + 1,
      truck_owner_name: params.truck_owner_name || "",
      do_no: params.do_no || "",
      vehicle_no: params.vehicle_no || "",
    };

    const response = await API.get(`/api/export-tds-freight-list/`, {
      params: queryParams,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });

    return {
      success: true,
      data: response.data,
      headers: response.headers,
    };
  } catch (error) {
    console.error("Export TDS Freight List API Error:", error);
    return {
      success: false,
      error: error.response?.data?.message || "Failed to export report",
    };
  }
};

export const exportFreightNotApplicableListExcel = async (params) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));

    const queryParams = {
      com_name: params.com_name || localStorage.getItem("com_name"),
      year: params.year || new Date().getFullYear(),
      do_no: params.do_no || "",
      client_name: params.client_name || "",
    };

    const response = await API.get(`/api/export-freight-not-applicable-list/`, {
      params: queryParams,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });

    return {
      success: true,
      data: response.data,
      headers: response.headers,
    };
  } catch (error) {
    console.error("Export Freight Not Applicable List API Error:", error);
    return {
      success: false,
      error: error.response?.data?.message || "Failed to export report",
    };
  }
};